import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fds-buttonLoading',
  templateUrl: './rds-button-loading.component.html',
  styleUrls: ['./rds-button-loading.component.scss']
})
export class FdsButtonLoadingComponent implements OnInit {

  @Input() classStyle:string = 'btn-primary';

  constructor() { }

  ngOnInit() {
  }

}
